import { Component, Input } from "@angular/core";
import { SelectionChangeInfo } from "devextreme/ui/collection/ui.collection_widget.base";
import { SelectionChangingEvent } from "devextreme/ui/stepper_types";
import { lastValueFrom, Observable } from "rxjs";

export interface IProgressStep<T = any> {
    label?: string;
    icon?: string;
    completed?: boolean;
    onClicked?: (item: IProgressStep<T>, idx: number) => Observable<boolean>;
    disabled?: boolean;
    data?: T;
}

@Component({
    selector: "adapt-stepped-progress-bar",
    templateUrl: "./stepped-progress-bar.component.html",
    styleUrl: "./stepped-progress-bar.component.css",
    standalone: false,
})
export class SteppedProgressBarComponent<T> {
    @Input() public steps!: IProgressStep<T>[];
    @Input() public currentStepIdx = 0;
    @Input() public showTitles = true;
    @Input() public labelOnly = false;
    @Input() public disabled = false;

    public async onSelectionChanging(e: SelectionChangingEvent<IProgressStep<T>>) {
        const { addedItems } = e as SelectionChangeInfo<IProgressStep<T>>;
        const step = addedItems[0];
        const index = this.steps.indexOf(step);

        if (this.currentStepIdx === index) {
            e.cancel = true;
            return;
        }

        if (step.onClicked) {
            const allowClick = await lastValueFrom(step.onClicked(step, index));
            if (!allowClick) {
                e.cancel = true;
                return;
            }
        }
    }
}
